<div class="bl-font-color--steel bl-display--flex bl-margin-bottom--8">
  <span [id]="field.id" class="bl-font-weight--800 bl-margin-right--24 bl-margin-bottom--0">
    {{field.label}}
    <span *ngIf="field.config.subLabel != null"
      class="bl-font-weight--400 bl-font-color--silver bl-display--block">
      {{field.config.subLabel}}
    </span>
  </span>
  <span class="bl-flex--auto bl-margin-bottom--0 {{formatter}}" *ngIf="field.config.content"
    [innerHtml]="field.parse(field.config.content)|safe:'html'"></span>

  <span *ngIf="showContent && formatter !== 'block'" class="bl-flex--auto bl-margin-bottom--0 {{formatter}}"
    [attr.aria-labelledby]="field.id">
    {{ field.readableValue | mask:field.config.mask }}
    {{ field.config.postfix || '' }}
  </span>
  <button [disabled]="!showObfuscatedValue" type="button" class="bl-input-append input-eye-icon" id="reveal-password"
    (click)="showUnObfuscatedValue();">
    <i [ngClass]="showObfuscatedValue ? 'cu-eye' : 'cu-eye-slash'"></i>
    <span class="bl-screen-reader-only">
      {{'cuLogin/revealPassword' | dictionary}}
    </span>
  </button>
</div>
<p *ngIf="showContent" class="bl-flex--auto bl-margin-bottom--24 bl-font-size--18 bl-font-weight--800"
  [attr.aria-labelledby]="field.id" [hidden]="showObfuscatedValue">
  {{ field.readableValue | mask:field.config.mask }}
  {{ field.config.postfix || '' }}
</p>
<p *ngIf="showContent" class="bl-flex--auto bl-margin-bottom--24 bl-font-size--18 bl-font-weight--800"
  [hidden]="!showObfuscatedValue">
  {{ field.config.placeholder }}
  {{ field.config.postfix || '' }}
</p>
